import { debounce } from "lodash-es"
import { useEffect, useState } from "react"

export function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)
  useEffect(() => {
    const handleResize = debounce(() => setWindowWidth(window.innerWidth), 400, {
      leading: true,
      trailing: true,
    })
    handleResize()
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
      handleResize.cancel()
    }
  }, [])

  return windowWidth
}
